// This component has been added ad-hoc by sales-leader-insights-fe team: https://private.hubteam.com/janus/groups/hs-sales-leader-insights-fe
// For any questions/concerns, please use Slack channel: #sales-leader-insights-fe

import FormattedMessage from 'I18n/components/FormattedMessage';
import getTranscriptSettingsUrl from '../../utils/getTranscriptSettingsUrl';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TranscriptSettingTooltipTitle = ({
  isTranscriptionAdmin,
  onClickGoToSettings
}) => isTranscriptionAdmin ? /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "transcriptQuickFilter.transcriptSettingPlaceholder.adminTooltip.body"
    })
  }), /*#__PURE__*/_jsx(Link, {
    onClick: onClickGoToSettings,
    href: getTranscriptSettingsUrl(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "transcriptQuickFilter.transcriptSettingPlaceholder.adminTooltip.cta"
    })
  })]
}) : /*#__PURE__*/_jsx("p", {
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "transcriptQuickFilter.transcriptSettingPlaceholder.nonAdminTooltip.body"
  })
});